import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

export type StyledAreaProps = {
  height?: string;
};

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
`;

const Area = styled.textarea<StyledAreaProps>`
  display: block;

  width: 100%;
  height: ${({ height }) => (height ? `${height}rem` : 'auto')};
  min-height: 6.6rem;
  padding: 0.6rem 1.2rem;
  margin-left: 0;

  border: 0.1rem solid ${pickColor('borderColorDarkSecondary')};
  border-radius: ${({ theme }) => theme.borderRadius.base};

  font-weight: lighter;

  resize: none;

  &:disabled {
    background-color: ${pickColor('gray')};
    border-color: ${pickColor('borderDisabled')};
  }
`;

export { Container, Area };
